import React from "react";

const FeatureCard = ({ icon, title, description }) => (
    <div className="col-lg-3 col-md-6 mb-sm-20">
        <div>
            <img src={icon} className="mb20" alt={title} />
            <h4>{title}</h4>
            <p>{description}</p>
        </div>
    </div>
);

const Section = () => {
    const content = {
        subtitle: "Incredibly features",
        title: "Premium Game Server",
        features: [
            {
                icon: "./img/icons/1.png",
                title: "Super Quick Setup",
                description:
                    "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
            },
            {
                icon: "./img/icons/2.png",
                title: "Premium Hardware",
                description:
                    "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
            },
            {
                icon: "./img/icons/3.png",
                title: "DDos Protection",
                description:
                    "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
            },
            {
                icon: "./img/icons/4.png",
                title: "Fast Support",
                description:
                    "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
            },
        ],
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="subtitle mb-3">{content.subtitle}</div>
                    <h2 className="mb20">{content.title}</h2>
                </div>

                <div className="col-lg-6"></div>

                {content.features.map((feature, index) => (
                    <FeatureCard key={index} {...feature} />
                ))}
            </div>
        </div>
    );
};

export default Section;
